import type { RouteObject } from "react-router";
import MeditationsPage from "./ui/pages/MeditationsPage";
import MeditationEditorPage from "./ui/pages/MeditationEditorPage";
import MeditationWizardPage from "./ui/pages/MeditationWizardPage";

export const meditationRoutes: RouteObject[] = [
    { path: "/meditations", element: <MeditationsPage /> },
    // Making one and coming back to one are different jobs: the first asks
    // three questions in order, the second shows the whole meditation at once.
    { path: "/meditations/new", element: <MeditationWizardPage /> },
    { path: "/meditations/:meditationId", element: <MeditationEditorPage /> },
];
